import { useLocation } from 'react-router-dom';

import {
  normalizeCasesFiltersToApiParams,
  CourtSearchPage,
  useCasesSearch,
  useQueryParams,
} from '../shared';
import { type PACERResponse } from '../types';

import { CasesResults } from './CasesResults';
import {
  CasesSearchForm,
  type CasesSearchFormData,
  type CasesSearchType,
} from './CasesSearchForm';

const CASES_QUERY_PREFIX_MAP: Record<string, CasesSearchType> = {
  'court_id:': 'courtId',
  'docketNumber:': 'docketNumber',
  'caseName:': 'caseName',
  'assignedTo:': 'assignedToJudge',
};

export const CasesSearch = () => {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const query = queryParams.get('query') || '';
  const exactMatchParam = queryParams.get('exact_match');
  const initialExactMatch = exactMatchParam !== 'false';

  const normalizeFilters = (filters: unknown) =>
    normalizeCasesFiltersToApiParams(
      filters as Parameters<typeof normalizeCasesFiltersToApiParams>[0]
    );

  return (
    <CourtSearchPage<PACERResponse, CasesSearchFormData, CasesSearchType>
      queryPrefixMap={CASES_QUERY_PREFIX_MAP}
      normalizeFilters={normalizeFilters}
      useSearchHook={useCasesSearch}
      initialQuery={query}
      initialExactMatch={initialExactMatch}
      SearchForm={CasesSearchForm}
      ResultsComponent={CasesResults}
    />
  );
};
